<mat-form-field>
  <input matInput [matDatepicker]="picker" [value]="date?.toISOString()" (dateChange)="onDateSelected($event?.value)">
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
